"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xRequestCallerSimplifier = void 0;
const xRequestCallerSimplifier = (caller) => {
    const callerSplitted = (caller || "unknown").replace(/-(prod|staging|dev).*/, "").split("-");
    const callerMax2Parts = callerSplitted.length > 2 ? callerSplitted.slice(0, 2) : callerSplitted;
    return callerMax2Parts.join("-");
};
exports.xRequestCallerSimplifier = xRequestCallerSimplifier;
//# sourceMappingURL=XRequestCallerIdSimplifier.js.map